import { errorHandler } from "@/APIs/errorHandler";

/**
 * Format a number with a leading 0 when under 10
 * @param number
 * @returns string
 */
export const formatNumberWithLeading0 = (number: any): string => {
  return `${number}`.padStart(2, "0");
};

export const formatCurrency = (
  amount: number,
  currency: string = "GBP"
): string => {
  return amount.toLocaleString(undefined, {
    style: "currency",
    currency
  });
};

export const parseDepositAmount = (
  amount: number | { amount: number }
): number => {
  return typeof amount === "object"
    ? parseFloat(amount.amount?.toString() || "0")
    : parseFloat(amount?.toString() || "0");
};

/**
 * Get the currency symbol for a given currency code using Intl.NumberFormat
 * @param currency - The currency code (e.g., 'GBP', 'USD', 'EUR')
 * @returns Currency symbol
 */
export const getCurrencySymbol = (currency: string): string => {
  if (!currency || currency.trim() === "") {
    return currency;
  }
  try {
    const formatter = new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });

    const parts = formatter.formatToParts(0);
    const currencyPart = parts.find((part) => part.type === "currency");
    return currencyPart?.value ?? currency;
  } catch (error) {
    errorHandler(error, "");
    return currency;
  }
};
